import PropTypes from "prop-types";
import { LoadingButton } from "@mui/lab";

import { useScreen } from "hooks";

const ContinueButton = ({ loading, disabled, onClick }) => {
  const { isMobile } = useScreen();

  return (
    <LoadingButton
      variant="contained"
      color="primary"
      size={isMobile ? "small" : "large"}
      loading={loading}
      disabled={disabled}
      onClick={onClick}
    >
      Continue
    </LoadingButton>
  );
};

ContinueButton.propTypes = {
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

export default ContinueButton;
